import React from 'react'
import { Helmet } from 'react-helmet'

const Head = () => {
	return (
		<Helmet>
			<title>O'qituvchilar</title>
		</Helmet>
	)
}

export default Head
